import DIYPricing from "./DIYPricing";

export default DIYPricing;



// WEBPACK FOOTER //
// ./src/components/Pricebook/DIYPricing/index.js